(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alleon-fit-assistant"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alleon-fit-assistant')) {
class AlleonFitAssistant extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready=true;
this.strings=JSON.parse(this.querySelector('[data-messages]').textContent);
this.controls=Object.fromEntries([...this.querySelectorAll('[data-field]')].map(e=>[e.dataset.field,e]));
this.result=this.querySelector('[data-result]');
this.controls.chart.value=this.dataset.chart;
this.controls.category.value=this.dataset.category;
this.addEventListener('change',()=>this.update());
this.addEventListener('input',()=>{this.result.hidden=true;});
this.querySelector('[data-calculate]').addEventListener('click',()=>this.calculate());
this.querySelector('[data-reset]').addEventListener('click',()=>{['chest','waist','hips'].forEach(k=>this.controls[k].value='');this.result.hidden=true;this.controls[this.keys[0]].focus();});
this.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.tagName==='INPUT'){e.preventDefault();this.calculate();}});
this.update();
}
update() {
const men=this.controls.chart.value==='men';
this.controls.category.disabled=men;
if(men)this.controls.category.value='top';
this.keys=this.controls.category.value==='bottom'?['waist','hips']:this.controls.category.value==='all'?['chest','waist','hips']:['chest','waist'];
['chest','waist','hips'].forEach(k=>{this.controls[k].closest('label').hidden=!this.keys.includes(k);this.controls[k].removeAttribute('aria-invalid');});
this.result.hidden=true;
}
calculate() {
const s=this.strings,c=this.controls;
const vals=this.keys.map(k=>Number(c[k].value.trim().replace(',','.')));
const bad=this.keys.filter((k,i)=>!/^\d{1,3}([.,]\d{1,2})?$/.test(c[k].value.trim())||!Number.isFinite(vals[i])||vals[i]<30||vals[i]>250);
this.result.replaceChildren();
const add=(txt,strong=false)=>{const el=document.createElement(strong?'strong':'p');el.textContent=txt;this.result.append(el);};
this.result.hidden=false;
if(bad.length){add(s.invalid);bad.forEach(k=>c[k].setAttribute('aria-invalid','true'));c[bad[0]].focus();return;}
this.keys.forEach(k=>c[k].removeAttribute('aria-invalid'));
const sizes=['XS','S','M','L','XL','XXL'];
const tables={
women:{chest:[[78,82],[82,90],[90,98],[98,107],[107,119],[119,131]],waist:[[64,66],[66,74],[74,82.5],[82.5,93],[93,105],[105,117.5]],hips:[[86,90],[90,97.5],[97.5,103.5],[103.5,110.5],[110.5,120.5],[120.5,131]]},
men:{chest:[[78,86],[86,94],[94,102],[102,110],[110,118],[118,126]],waist:[[66,74],[74,82],[82,90],[90,98.5],[98.5,107.5],[107.5,116.5]]}};
const matches=this.keys.map((k,j)=>tables[c.chart.value][k].flatMap(([lo,hi],i)=>vals[j]>=lo&&vals[j]<=hi?[i]:[]));
const common=sizes.map((_,i)=>i).filter(i=>matches.every(m=>m.includes(i)));
if(matches.some(m=>!m.length)) add(s.outside,true);
else if(!common.length) add(s.mixed,true);
else {add(s.recommend+' '+common.map(i=>sizes[i]).join(' '+s.or+' '),true);if(common.length>1)add(s.boundary);
const offered=(this.dataset.sizes||'').split('|').filter(Boolean).map(x=>x.trim().toUpperCase());
if(offered.length&&common.every(i=>!offered.includes(sizes[i])))add(s.missing);
}
this.keys.forEach((k,i)=>add(s[k]+': '+(matches[i].map(j=>sizes[j]).join(' / ')||'—')));
if(c.fit.value!=='regular')add(s.fit_note);
if(this.dataset.product==='true')add(s.availability);
add(s.note);
}
}
customElements.define('alleon-fit-assistant',AlleonFitAssistant);
}
  } catch(e) { console.error(e); }
})();

})();
